// Module
var code = "<div> <canvas id=\"pie-canvas\"></canvas> </div>";
// Exports
module.exports = code;